import React, { useEffect, useState, useContext, useId,useRef,useCallback } from 'react';
import {
    Row,
    Col,
    Input,
    Button
} from "antd";

import TextField from '@mui/material/TextField';
import 'antd/dist/antd.css';


export default function Fooktest(prop) {

    const [newurl, setnewurl]       = useState('');
    const [tempurl, settempurl]       = useState('');
    
    return (
        <>
        <h1>testing</h1>
        <Row>
            <Col style={{width:"600px"}}> 
            <TextField
            value={tempurl}
            style={{width:"100%"}}
            id="outlined-desc"
           
            onChange={(val1) => settempurl(val1.target.value)}
            InputLabelProps={{
                shrink: true,
            }}
            /> 
            </Col>
            <Col>
            <Button onClick={(val) => setnewurl(tempurl)}>Change URL</Button>
            </Col>
        </Row>
       
        <iframe
            src={newurl}
            height="720"
            width="1280"
            allowfullscreen>
        </iframe>
        </>
    )
}